<template>
    <div class="pb-3">
        <div class="description">
            {{ template.description }}
        </div>
        <h5 class="subheader">Tags</h5>
        <div class="tags">
            <label v-for="tag in template.tags" :key="tag" class="tag">{{ tag }}</label>
        </div>
        <h5 class="subheader">Questions</h5>
        <div class="questions">
            <div v-for="(q, i) in template.questions" :key="i" class="question">
                <b-button
                    v-b-toggle="'view-question' + i"
                    class="questions-toggle"
                    variant="light"
                    @click="clickToggle(i)"
                >
                    <!-- caret down -->
                    <svg v-if="!questionsToggle[i]" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         fill="currentColor" class="bi bi-caret-down-fill caret-icon" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                    <!-- caret up -->
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         fill="currentColor" class="bi bi-caret-up-fill caret-icon" viewBox="0 0 16 16">
                        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                    </svg>
                    <div class="mx-2">
                        Q{{ i + 1 }}. {{ q.content.title }}
                    </div>
                </b-button>

                <b-collapse :id="'view-question' + i" class="questions-content">
                    <!-- readonly as default-->
                    <fieldset :disabled="readonly">
                        <div>
                            <MultiChoice  v-if="q.qType == 'multi-choice'"  :index="i" :content="q.content" />
                            <MultiSelect  v-if="q.qType == 'multi-select'"  :index="i" :content="q.content" />
                            <Dropdown    v-if="q.qType == 'dropdown'"      :index="i" :content="q.content" />
                            <TextAnswer  v-if="q.qType == 'text-answer'"    :index="i" :content="q.content" />
                            <LinearScale v-if="q.qType == 'linear-scale'"    :index="i" :content="q.content" />
                        </div>
                    </fieldset>
                </b-collapse>
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import ViewMultiChoice from './ViewMultiChoice.vue'
import ViewMultiSelect from './ViewMultiSelect.vue'
import ViewDropdown from './ViewDropdown.vue'
import ViewLinearScale from './ViewLinearScale.vue'
import ViewTextAnswer from './ViewTextAnswer.vue'

export default {
    name: 'ViewTemplate',
    components: {
        MultiChoice: ViewMultiChoice,
        MultiSelect: ViewMultiSelect,
        Dropdown: ViewDropdown,
        TextAnswer: ViewTextAnswer,
        LinearScale: ViewLinearScale
    },
    props: {
        template: {
            type: Object,
            default: () => ({ questions: [], tags: [], description: '' })
        },
        index: Number,
        //readonly, deafault true
        readonly: { type: Boolean, default: true }
    },
    data() {
        return {
            questionsToggle: [] 
        }
    },
    mounted () {
        const list = (this.template && Array.isArray(this.template.questions))
            ? this.template.questions
            : [];
        this.questionsToggle = list.map(() => false);
    },
    methods: {
        clickToggle(index) {
            Vue.set(this.questionsToggle, index, !this.questionsToggle[index])
        }
    }
}
</script>

<style scoped>
.description {
    font-style: italic;
    color: #848d94;
}

.subheader {
    color: #ff8e4d;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
}

.tags {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
}

.tag {
  background-color: #DB3360 !important;
  color: white;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.25rem;
  padding: 0.5rem;
  border-radius: 15px;
}

.questions-toggle {
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    color: #000;
    background: #f3f4f6 !important;  
    border: 1px solid #e5e7eb !important;
    box-shadow: none !important;
}
.questions-toggle:hover {
    background: #eef2f7 !important;
}

.questions-content {
    width: 100%;
    margin: 0 2rem;
}

.caret-icon {
    min-width: 16px;
    min-height: 16px;
}

.question:last-child hr { display: none; }

hr { margin: 0.5rem 0; }
</style>



// WEBPACK FOOTER //
// src/components/survey-create/search-templates-components/ViewTemplate.vue